import script from "./CastomSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./CastomSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./CastomSwitcher.vue?vue&type=style&index=0&id=356b95a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356b95a8"]])

export default __exports__